<template>
  <div id="new-edit-budget-dialog">
    <res-dialog :showDialog="showHelp"
                titleClass="resBlue darken-1 white--text"
                iconColor="white"
                cancelButtonText="Close"
                :cancelButtonOnly="true"
                cancelButtonColor="resBlue darken-1"
                :maxWidth="maxWidth / 3 * 2"
                :setWidth="width / 3 * 2"
                :setHeight="600"
                attach="#new-edit-budget-dialog"
                @cancel="closeHelp">
      <new-budgets-help :openSection="openHelpSection"></new-budgets-help>
    </res-dialog>
    <res-dialog :title="'Creating Budget'"
                :showDialog="showMessageDialog"
                :smallTitleIcon="true"
                :cancelButtonOnly="true"
                :saveButtonOnly="true"               
                :iconColor="'white'"
                iconTitle="mdi-calendar-blank-multiple"
                :showTitleIcon="false"
                :titleClass="'resBlue darken-1 white--text'"
                :hideClose ="true">
      <v-container>
        <v-card-text>  
          <span>
        {{ dialogMessage }}
      </span>
        </v-card-text>
      </v-container>
    </res-dialog>
    <res-dialog :showDialog="showDialog"
                title="Budget Settings"
                :titleClass="'resBlue darken-1 white--text'"
                :iconColor="'white'"
                :maxWidth="maxWidth"
                :setWidth="width"
                :saveButtonOnly="true"
                :cancelButtonOnly="true"
                @cancel="cancel"
                attach="#new-edit-budget-dialog"
                :setHeight="height">
      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <template v-for="(step, stepNum) in steps">
            <v-stepper-step :step="stepNum + 1"
                            :key="stepNum"
                            :complete="step.isComplete(budgetSettings)">
            </v-stepper-step>
            <v-divider :key="'div' + stepNum"></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-12"
                    color="white"
                    height="400px">
              <span class="step-title">{{steps[0].name}}</span>
              <br />
              <span class="banner" v-if="!Boolean(budgetIterationId)">The specific settings below cannot be changed at a later date.</span>
              <span class="banner" v-if="Boolean(budgetIterationId)">The settings below cannot be changed because the budget has already been created.</span>
              <br />
              <v-row align-content="end">
                <v-col cols="5">
                  <label>Property</label>
                  <property-selector ref="propertySelector" :readonly="Boolean(budgetIterationId)" v-model="budgetSettings.property" elementId="import-property-selector"></property-selector>
                </v-col>
                <v-col cols="2"></v-col>
                <v-col cols="3" v-if="!Boolean(budgetIterationId)">
                  <v-checkbox class="res-checkbox" label="Copy the Working Rows from the Budget selected below" v-model="copyWorkingRows">
                  </v-checkbox>
                </v-col>
                <v-col cols="1" v-if="!Boolean(budgetIterationId)">
                  <v-tooltip top max-width="500px">
                    <span>Only the Working Rows will be copied. No numbers from the source budget will be copied.</span>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="">
                        <v-icon class="nudge-left">info</v-icon>
                      </div>
                    </template>
                  </v-tooltip>
                </v-col>
                <v-col cols="1" class="pb-0">
                  <div class="help-controls step-down" @click="openHelp(0)">
                    <span class="help-label">Help</span>
                    <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <label>Year</label>
                  <fiscal-year-selector :readonly="Boolean(budgetIterationId)" v-model="budgetSettings.year" :propertyId="budgetSettings.property.value" elementId="import-year-selector"></fiscal-year-selector>
                </v-col>
                <v-col cols="2"></v-col>
                  <v-col cols="3" v-show="copyWorkingRows">
                    <label>Property</label>
                    <property-selector ref="wrPropertySelector" v-model="copyWorkingRowsPropertyId" elementId="copy-wr-property-selector"></property-selector>
                  </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <label id="start-month-label">
                    Start Month
                    <v-tooltip top max-width="500px" nudge-right="150">
                      <span>Start month defaults to the beginning of your accounting year. This can be changed. You can budget for any 12 month period desired.</span>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="inline">
                          <v-icon>info</v-icon>
                        </div>
                      </template>
                    </v-tooltip>
                  </label>
                  <res-select :readonly="Boolean(budgetIterationId)" class="start-month-selector" v-model="budgetSettings.startMonth" :items="startMonthOptions" :loading="currentLoading" attach="#start-month-label"></res-select>
                </v-col>
                <v-col cols="2"></v-col>
                <v-col cols="2" v-show="copyWorkingRows">
                  <label>Year</label>
                  <fiscal-year-selector v-model="copyWorkingRowsYear" :propertyId="copyWorkingRowsPropertyId.value" elementId="copy-wr-year-selector" withBudget></fiscal-year-selector>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <label>Accounting Basis</label>
                  <res-select :readonly="Boolean(budgetIterationId)" class="accounting-basis-selector" v-model="budgetSettings.accountingBasisId" :items="accountingBasiiOptions" :loading="currentLoading"></res-select>
                </v-col>
                <v-col cols="2"></v-col>
                <v-col cols="3" v-show="copyWorkingRows">
                  <label>Budget</label>
                  <res-select class="copy-wr-budget-selector" v-model="budgetSettings.cloneWorkingRowsFromBudgetIterationId" :items="copyableWorkingRowSets" :loading="currentLoading"></res-select>
                </v-col>
              </v-row>
            </v-card>

            <v-btn text
                   @click="cancel">
              Cancel
            </v-btn>
            <v-btn color="primary"
                   :disabled="!steps[0].isComplete(budgetSettings)"
                   @click="currentStep++">
              Next
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-12"
                    color="white"
                    height="400px">

              <span class="step-title">{{steps[1].name}}</span>
              <br />
              <span class="banner">You may change the settings below later from within 'Settings'.</span>
              <br />
              <v-row align-content="end">
                <v-col cols="9">
                  <label>Version Description (Optional)</label>
                  <res-text-field v-model="budgetSettings.description"></res-text-field>
                </v-col>
                <v-col cols="3">
                      <div class="help-controls step-down" @click="openHelp(1)">
                        <span class="help-label">Help</span>
                        <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
                      </div>
                </v-col>
              </v-row>

              <span class="banner mt-2" v-if="budgetSettings.status != 'Open'">The settings below cannot be changed because the budget is not in 'open' status.</span>
              <v-row>
                <v-col cols="6">
                  <label>GL Account Template</label>
                  <template-selector ref="templateSelector" :readonly="!canEdit" v-model="budgetSettings.template" :propertyId="budgetSettings.property.value" :menuProps="{top: true, nudgeBottom: '50px'}"></template-selector>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label>
                    Estimate Future Historicals for GL Accounts
                    <v-tooltip top max-width="500px" nudge-right="50">
                      <ul>
                        <li>When viewing your General Ledger historical numbers, all of the months may not have numbers because the year may not be complete.</li>
                        <li>For Example: If you are working on your 2022 budget in September of 2021, then there will be no historical numbers for September, October, November or December of 2021 because these months have not happened.</li>
                        <li>These choices will offer you three options to populate those missing future months.</li>
                      </ul>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="inline">
                          <v-icon>info</v-icon>
                        </div>
                      </template>
                    </v-tooltip>
                  </label>
                  <res-select :readonly="!canEdit" class="estimate-future-historicals-selector" v-model="budgetSettings.estimateFutureHistoricalsOption" :items="estimateFutureHistoricalsOptions" :loading="currentLoading"></res-select>
                </v-col>
                <span v-if="this.budgetSettings.estimateFutureHistoricalsOption != '5'" class="step-down pt-5">and start in</span>
                <v-col v-if="this.budgetSettings.estimateFutureHistoricalsOption != '5'" cols="3" class="step-down pt-4">
                  <res-select :readonly="!canEdit" class="estimate-future-historicals-month-selector" v-model="budgetSettings.estimateFutureHistoricalOptionMonthOption" :items="estimateFutureHistoricalOptionMonthOptions" :loading="currentLoading" :menuProps="{top: true,nudgeBottom: '50px'}"></res-select>
                </v-col>
                <span v-if="this.budgetSettings.estimateFutureHistoricalsOption != '5'" class="step-down pt-5 pl-1">month</span>
                <div v-if="this.budgetSettings.estimateFutureHistoricalsOption == '5'"></div>
              </v-row>
              <v-row v-show=false>
                <v-col cols="6">
                  <label>
                    Estimate Future Historicals for Occupancy Workbooks
                    <v-tooltip top max-width="500px" nudge-right="50">
                      <ul>
                        <li>When viewing your Occupancy workbook Historical numbers, all of the months may not have numbers because the year may not be complete.</li>
                        <li>For Example: If you are working on your 2022 budget in September of 2021, then there will be no historical numbers for September, October, November or December of 2021 because these months have not happened.</li>
                        <li>These choices will offer you two options to populate those missing future months.</li>
                      </ul>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="inline">
                          <v-icon>info</v-icon>
                        </div>
                      </template>
                    </v-tooltip>
                  </label>
                  <res-select :readonly="!canEdit" class="estimate-future-historicals-selector" v-model="budgetSettings.estimateFutureHistoricalsOccupancyWorkbooksOption" :items="estimateFutureHistoricalsOccupancyWorkbooksOptions" :loading="currentLoading"></res-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label>Approval Workflow</label>
                  <res-select :readonly="!canEdit" v-model="budgetSettings.approvalWorkflowId" :items="approvalworkflowOptions"></res-select>
                </v-col>
              </v-row>
            </v-card>

            <v-btn text
                   @click="currentStep--">
              Back
            </v-btn>
            <v-btn color="primary"
                   :disabled="!steps[1].isComplete(budgetSettings)"
                   @click="currentStep++">
              Next
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="mb-12"
                    color="white"
                    height="100%">

              <span class="step-title">{{steps[2].name}}</span>
              <br />
              <span class="banner" v-if="!Boolean(budgetIterationId)">You may change the settings below later from within 'Settings'.</span>
              <span class="banner" v-if="budgetSettings.status != 'Open'">The settings below cannot be changed because the budget is not in 'open' status.</span>
              <br />
              <v-row>
                <v-col cols="10">
                  <label>New Lease Calculations</label>
                  <res-select :readonly="!canEdit" class="new-lease-calculations-selector" v-model="budgetSettings.newLeaseCalculationOption" :items="newLeaseCalculationOptions" :loading="currentLoading"></res-select>
                </v-col>
                <v-col cols="2">
                  <div class="help-controls step-down" @click="openHelp(2)">
                    <span class="help-label">Help</span>
                    <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="budgetSettings.newLeaseCalculationOption==1" class="pl-3 mt-0">
                <span class="pt-5">The discount will be</span>
                <v-col cols="1">
                  <res-text-field :readonly="!canEdit" v-model="budgetSettings.discountMarketRentPercentage"></res-text-field>
                </v-col>
                <span class="pt-5">% of Market Rent.</span>
              </v-row>

              <v-row v-if="budgetSettings.newLeaseCalculationOption==3" class="pl-3 mt-0">
                <span class="pt-5">This recurring concession will be</span>
                <v-col cols="1">
                  <res-text-field :readonly="!canEdit" v-model="budgetSettings.newRecurringConcessionMarketRentPercentage"></res-text-field>
                </v-col>
                <span class="pt-5">% of Market Rent and will use concession transaction category:</span>
                <v-col cols="12" class="pl-0 px-6 pt-0">
                  <v-combobox :readonly="!canEdit" ref="newRecurringConcessionCombo" v-model="budgetSettings.newRecurringConcessionTransactionCategoryId" :items="transactionCategories" outlined dense flat height="12"></v-combobox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <label>Renewal Pricing Calculations</label>
                  <res-select :readonly="!canEdit" class="renewal-pricing-calculations-selector" v-model="budgetSettings.renewalPricingCalculationOption" :items="renewalPricingCalculationOptions" :loading="currentLoading"></res-select>
                </v-col>
              </v-row>

              <v-row v-if="budgetSettings.renewalPricingCalculationOption==1" class="pl-3 mt-0">
                <span class="pt-5">This increase will be</span>
                <v-col cols="1">
                  <res-text-field class="short" :readonly="!canEdit" v-model="budgetSettings.increaseOverExistingRentAmount"></res-text-field>
                </v-col>
                <v-col cols="2">
                  <res-select :readonly="!canEdit" v-model="budgetSettings.increaseOverExistingRentDenomination" :items="denominationOptions"></res-select>
                </v-col>
                <span class="pt-5">over existing rent.</span>
                <v-col cols="3">
                  <v-checkbox class="mx-2 ma-0 pb-2 res-checkbox" label="Capped at Market Rent" v-model="budgetSettings.capRentIncreaseAtMarketRent"></v-checkbox>
                </v-col>
              </v-row>

              <v-row v-if="budgetSettings.renewalPricingCalculationOption==3" class="pl-3 mt-0">
                <span class="pt-5">This recurring concession will be</span>
                <v-col cols="1">
                  <res-text-field :readonly="!canEdit" v-model="budgetSettings.renewalRecurringConcessionMarketRentPercentage"></res-text-field>
                </v-col>
                <span class="pt-5">% of Market Rent and will use concession transaction category:</span>
                <v-col cols="12" class="pl-0 px-6 pt-0">
                  <v-combobox :readonly="!canEdit" ref="rewewalRecurringConcessionCombo" v-model="budgetSettings.renewalRecurringConcessionTransactionCategoryId" :items="transactionCategories" outlined dense flat height="12"></v-combobox>
                </v-col>
              </v-row>
            </v-card>

            <v-btn text
                   @click="currentStep--">
              Back
            </v-btn>
            <v-btn color="primary"
                   :disabled="!steps[2].isComplete(budgetSettings)"
                   @click="currentStep++">
              Next
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card class="mb-12 scrollable-card"
                    color="white"
                    height="420px">

              <span class="step-title">{{steps[3].name}}</span>
              <br />
              <span class="banner" v-if="!Boolean(budgetIterationId)">You may change the settings below later from within 'Settings'.</span>
              <span class="banner" v-if="budgetSettings.status != 'Open'">The settings below cannot be changed because the budget is not in 'open' status.</span>
              <br />
              <v-row>
                <v-col cols="9" class="py-0">
                  <label>Other Concessions (Optional)</label>
                </v-col>
                <v-col cols="3" class="py-0">
                  <div class="help-controls" @click="openHelp(3)">
                    <span class="help-label">Help</span>
                    <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
                  </div>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span>Want to enter budget numbers for additional concessions?  If so, please select them below:</span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-combobox :readonly="!canEdit" ref="otherConcessionTransactionCategoriesCombo" color="resBlue darken-1" dense outlined class="py-0" multiple v-model="budgetSettings.otherConcessionTransactionCategories" :items="transactionCategories"></v-combobox>
                </v-col>
              </v-row>

              <v-row class="py-0 mt-0">
                <v-col cols="10" class="py-0">
                  <label>Bad Debt</label>
                  <res-select :readonly="!canEdit" v-model="budgetSettings.badDebtOption" :items="badDebtOptions"></res-select>
                </v-col>
              </v-row>

              <v-row v-if="budgetSettings.badDebtOption==1" class="pl-3 py-0">
                <span class="pt-5">This will be</span>
                <v-col cols="1">
                  <res-text-field :readonly="!canEdit" v-model="budgetSettings.badDebtGLPercentage"></res-text-field>
                </v-col>
                <span class="pt-5">% of</span>
                <v-col cols="8">
                  <v-combobox :readonly="!canEdit" ref="glCombo" color="resBlue darken-1" v-model="budgetSettings.badDebtGLAccount" :filter="(item, queryText, itemText) => isNaN(queryText) ? itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) !== -1 : itemText.toLocaleLowerCase().startsWith(queryText.toLocaleLowerCase())" :items="glAccounts" outlined dense flat height="12"></v-combobox>
                </v-col>
              </v-row>

              <br v-if="budgetSettings.badDebtOption!==1" />
              <v-row class="py-0 mt-0">
                <v-col cols="10" class="py-0">
                  <span>Bad Debt Transaction Category is: </span>
                </v-col>
                <v-col cols="10" class="py-0">
                  <v-combobox :readonly="!canEdit" ref="badDebtCombo" color="resBlue darken-1" v-model="budgetSettings.badDebtTransactionCategoryId" :items="transactionCategories" outlined dense flat height="12"></v-combobox>
                </v-col>
              </v-row>

            </v-card>

            <v-btn text
                   @click="currentStep--">
              Back
            </v-btn>
            <v-btn color="primary"
                   :disabled="!steps[3].isComplete(budgetSettings)"
                   @click="currentStep++">
              Next
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-card class="mb-12"
                    color="white"
                    height="100%">

              <span class="step-title">{{steps[4].name}}</span>
              <br />
              <span class="banner" v-if="!Boolean(budgetIterationId)">You may change the settings below later from within 'Settings'.</span>
              <span class="banner" v-if="budgetSettings.status != 'Open'">The settings below cannot be changed because the budget is not in 'open' status.</span>
              <br />
              <v-row align-content="center">
                <v-col cols="4"></v-col>
                <v-col cols="4">
                  <v-btn @click="manualLoadProjectedVacancies"
                         :color="canEdit ? 'resBlue darken-1' : 'resGrey darken-1'"
                         class="white--text">Load Projected Vacancies as of {{projectedVacancyDate | moment('MM/DD/YYYY')}}</v-btn>
                </v-col>
                <v-col cols="3"></v-col>
                <v-col cols="1">
                  <div class="help-controls" @click="openHelp(4)">
                    <span class="help-label">Help</span>
                    <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="py-0 my-0"></v-col>
                <v-col cols="4" class="py-0 my-0">This excludes Model/Admin/Down Units</v-col>
                <v-col cols="4" class="py-0 my-0"></v-col>
              </v-row>
              <v-row>
                <v-col cols="4"></v-col>
                <v-col cols="4">
                  <table cellpadding="0" cellspacing="0" style="display: block; height: 300px; overflow-y: scroll">
                    <thead>
                    <th class="resGrey--border resGrey lighten-1">Unit Type</th>
                    <th class="resGrey--border resGrey lighten-1"># Units</th>
                    </thead>
                    <tbody>
                      <tr :key="unitType.unitTypeId" v-for="unitType in budgetSettings.beginningVacancies">
                        <td class="resGrey--border resGrey lighten-1">{{unitType.unitTypeName}}</td>
                        <td class="resGrey--border white">
                          <res-text-field v-model="unitType.beginningVacancies" :readonly="currentLoading || !canEdit" :filled="currentLoading" @input="updateProjectionLastUpdatedDate"></res-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <span class="pr-12">Table last updated as of {{budgetSettings.projectionLastUpdatedDate | moment('MM/DD/YYYY')}}</span>
                </v-col>
                <v-col cols="4"></v-col>
              </v-row>
            </v-card>

            <v-btn text
                   @click="currentStep--">
              Back
            </v-btn>
            <v-btn v-if="!budgetIterationId"
                   color="primary"
                   :disabled="currentLoading"
                   @click="create">
              Create
            </v-btn>
            <v-btn v-if="budgetIterationId"
                   color="primary"
                   :disabled="currentLoading"
                   @click="save">
              Save
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </res-dialog>
  </div>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResSelect from '@/components/base/ResSelect.vue';
  import ResTextField from '@/components/base/ResTextField.vue';
  import TemplateSelector from '@/components/templates/TemplateSelector.vue';

  import PropertySelector from '@/components/properties/PropertySelector.vue';
  import FiscalYearSelector from '@/components/properties/FiscalYearSelector.vue';
  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';
  import NewBudgetsHelp from '@/components/help/NewBudgetsHelp.vue';
  import HelpableMixin from '@/mixins/Helpable.js';

  import accountService from '@/services/account';
  import budgetService from '@/services/budget';
  import glAccountService from '@/services/gl-account';
  import propertyService from '@/services/property';
  import unitTypeService from '@/services/unit-type';
  import workflowService from '@/services/workflow';

  import * as fiscalYearOperations from '@/utilities/fiscal-year-operations';

  import { mapActions } from 'vuex';
  import { mapGetters } from 'vuex';

  export default {
    props: {
      height: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      showDialog: {
        type: Boolean
      },
      width: {
        type: Number
      },
      budgetIterationId: {
        type: String,
        default: null
      }
    },
    mixins: [IsNullOrWhitespaceMixin, HelpableMixin],
    data() {
      return {
        currentStep: 1,
        steps: [
          {
            name: 'New Budget',
            isComplete: (budgetSettings) => { return Boolean((budgetSettings.property.value && budgetSettings.property.value.length > 1) && (budgetSettings.year && budgetSettings.year > 0) && budgetSettings.startMonth && budgetSettings.accountingBasisId); }
          },
          {
            name: 'General Settings',
            isComplete: (budgetSettings) => { return Boolean(budgetSettings.template && budgetSettings.estimateFutureHistoricalsOption && budgetSettings.estimateFutureHistoricalOptionMonthOption && budgetSettings.estimateFutureHistoricalsOccupancyWorkbooksOption); }
          },
          {
            name: 'Lease Calculations',
            isComplete: (budgetSettings) => {
              return Boolean(budgetSettings.newLeaseCalculationOption > 0 &&
                (budgetSettings.newLeaseCalculationOption == 1 ? budgetSettings.discountMarketRentPercentage > 0 : true) &&
                (budgetSettings.newLeaseCalculationOption == 3 ? budgetSettings.newRecurringConcessionMarketRentPercentage && budgetSettings.newRecurringConcessionTransactionCategoryId : true))
                &&
                Boolean(budgetSettings.renewalPricingCalculationOption > 0 &&
                  (budgetSettings.renewalPricingCalculationOption == 1 ? budgetSettings.increaseOverExistingRentAmount > 0 && budgetSettings.increaseOverExistingRentDenomination > 0 : true) &&
                  (budgetSettings.renewalPricingCalculationOption == 3 ? budgetSettings.renewalRecurringConcessionMarketRentPercentage && budgetSettings.renewalRecurringConcessionMarketRentPercentage && budgetSettings.renewalRecurringConcessionTransactionCategoryId : true))
            }
          },
          {
            name: 'Other Concessions and Bad Debt',
            isComplete: (budgetSettings) => {
              return Boolean(budgetSettings.badDebtOption &&
                (budgetSettings.badDebtOption > 1 || budgetSettings.badDebtGLPercentage && budgetSettings.badDebtGLAccount) &&
                budgetSettings.badDebtTransactionCategoryId)
            }
          },
          {
            name: 'Beginning Vacancies',
            isComplete: (budgetSettings) => { return !budgetSettings }
          }
        ],
        transactionCategories: [],
        approvalworkflowOptions: [],
        projectedVacancies: [],
        glAccounts: [],
        lastModifiedTimestamp: null,
        budgetSettings: {
          status: 'Open',//consider it open for frontend editing purposes before it's created
          property: { text: '', value: '' },
          year: null,
          accountingBasisId: 1,
          startMonth: '',
          description: '',
          template: '',
          estimateFutureHistoricalsOption: 1,
          estimateFutureHistoricalOptionMonthOption: 0,
          estimateFutureHistoricalsOccupancyWorkbooksOption: 1,
          newLeaseCalculationOption: 1,
          renewalPricingCalculationOption: 1,
          newRecurringConcessionMarketRentPercentage: 0,
          renewalRecurringConcessionMarketRentPercentage: 0,
          newRecurringConcessionTransactionCategoryId: null,
          renewalRecurringConcessionTransactionCategoryId: null,
          otherConcessionTransactionCategories: [],
          badDebtOption: 1,
          badDebtTransactionCategoryId: null,
          beginningVacancies: [],
          approvalWorkflowId: null,
          projectionLastUpdatedDate: new Date(),
          capRentIncreaseAtMarketRent: true,
          cloneWorkingRowsFromBudgetIterationId: null
        },
        showMessageDialog: false,
        dialogMessage: "Please wait one moment while your new budget is being created.",
        copyWorkingRows: false,
        copyWorkingRowsYear: 0,
        copyWorkingRowsPropertyId: {},
        copyableWorkingRowSets: []
      }
    },
    components: {
      ResDialog,
      ResSelect,
      ResTextField,
      PropertySelector,
      TemplateSelector,
      FiscalYearSelector,
      NewBudgetsHelp
    },
    methods: {
      ...mapActions(['changeLoading']),
      getMonthOptions(year, includeYear, startMonth) {
        startMonth = startMonth || 0;
        let priorYear = includeYear ? year - 1 : '';
        if (priorYear > 0 || !includeYear) {
          var months = [
            { text: 'January ', value: 1 },
            { text: 'February ', value: 2 },
            { text: 'March ', value: 3 },
            { text: 'April ', value: 4 },
            { text: 'May ', value: 5 },
            { text: 'June ', value: 6 },
            { text: 'July ', value: 7 },
            { text: 'August ', value: 8 },
            { text: 'September ', value: 9 },
            { text: 'October ', value: 10 },
            { text: 'November ', value: 11 },
            { text: 'December ', value: 12 }
          ];

          var returnMonths = [];
          for (var i = startMonth; i < startMonth + 12; i++) {
            var thisMonth = months[i % 12];
            thisMonth.text += i < 12 && i > 0 ? priorYear : i < 24 ? year : year + 1;
            returnMonths.push(thisMonth)
          }
          return returnMonths;
        }
        return []
      },
      async selectDefaultMonth(propertyId) {
        this.budgetSettings.startMonth = await propertyService.getPropertyFiscalYearStartMonth(propertyId);
      },
      async getConcessionTransactionCategories() {
        var result = await accountService.getTransactionCategories('Credit', this.budgetSettings.property.value);

        this.transactionCategories = result
          .filter((cat) => { return !cat.isUnitStatusVacancyLossLedgerItem && !cat.isUnitStatusVacancyLossLedgerItem })
          .map((cat) => { return { text: cat.name, value: cat.ledgerItemTypeId }; })
          .sort((a, b) => (a  && a.text || '').toLowerCase().localeCompare((b && b.text || '').toLowerCase()));
      },
      async loadAvailableWorkflows() {
        let workflowData = await workflowService.getDropdown();
        if (workflowData && workflowData.data) {
          let wfs = [];

          wfs.push({ text: 'No approval workflow selected', value: 0 });
          for (var i = 0; i < workflowData.data.length; i++) {
            wfs.push(workflowData.data[i]);
          }
          this.approvalworkflowOptions = wfs;
        } else {
          let wfs = [];
          wfs.push({ text: 'No approval workflow selected', value: 0 });
          this.approvalworkflowOptions = wfs;
        }

        this.budgetSettings.approvalWorkflowId = this.budgetSettings.approvalWorkflowId || this.approvalworkflowOptions[0].value
      },
      updateProjectionLastUpdatedDate() {
        this.budgetSettings.projectionLastUpdatedDate = new Date();
      },
      async manualLoadProjectedVacancies() {
        this.budgetSettings.projectionLastUpdatedDate = new Date();
        await this.loadProjectedVacancies();
      },
      async loadProjectedVacancies() {
        if (!this.projectedVacancyDate) {
          return;
        }
        this.changeLoading(true);
        var projectedVacancies = await unitTypeService.getProjectedVacancies(this.budgetSettings.property.value, this.projectedVacancyDate);
        (this.budgetSettings.beginningVacancies).forEach((item) => {
          let unitTypeVacancies = projectedVacancies.find(e => e.unitTypeId.toUpperCase() == item.unitTypeId.toUpperCase());
          if (unitTypeVacancies) {
            item.beginningVacancies = unitTypeVacancies.projectedVacancies;
          }
          else {
            item.beginningVacancies = 0;
          }
        });
        this.changeLoading(false);
      },
      async loadUnitTypes() {
        if (this.budgetSettings.property && this.budgetSettings.property.value && this.budgetSettings.property.value.length > 1) {
          this.budgetSettings.beginningVacancies = await unitTypeService.getUnitTypes(this.budgetSettings.property.value);
        }
      },
      async loadGlAccounts() {
        this.glAccounts = ((await glAccountService.getGlAccounts(null, 'Income')).concat(await glAccountService.getGlAccounts(null, 'Expense')))
          .sort((glA, glB) => { if (glA.number < glB.number) { return -1; } if (glA.number > glB.number) { return 1; } return 0; })
          .map((gl) => { return { text: gl.number + ' - ' + gl.name, value: gl.glAccountId }; });
      },
      async loadBudgetSettings() {
        if (!this.budgetIterationId) {
          return;
        }
        this.currentStep = 2;
        var budgetSettings = await budgetService.getBudgetSettings(this.budgetIterationId);

        this.budgetSettings = {
          status: budgetSettings.status,
          property: { text: budgetSettings.propertyName, value: budgetSettings.propertyId },
          year: budgetSettings.year,
          accountingBasisId: budgetSettings.accountingBasisId,
          startMonth: budgetSettings.startMonth,
          description: budgetSettings.description,
          template: { text: budgetSettings.templateTitle, value: budgetSettings.templateId },
          increaseOverExistingRentAmount: budgetSettings.increaseOverExistingRentAmount,
          increaseOverExistingRentDenomination: budgetSettings.increaseOverExistingRentDenomination,
          capRentIncreaseAtMarketRent: budgetSettings.capRentIncreaseAtMarketRent,
          discountMarketRentPercentage: budgetSettings.discountMarketRentPercentage,
          estimateFutureHistoricalsOption: budgetSettings.estimateFutureHistoricalsOption,
          estimateFutureHistoricalOptionMonthOption: budgetSettings.estimateFutureHistoricalOptionMonthOption,
          estimateFutureHistoricalsOccupancyWorkbooksOption: budgetSettings.estimateFutureHistoricalsOccupancyWorkbooksOption,
          newLeaseCalculationOption: budgetSettings.newLeaseCalculationOption,
          renewalPricingCalculationOption: budgetSettings.renewalPricingCalculationOption,
          newRecurringConcessionMarketRentPercentage: budgetSettings.newRecurringConcessionMarketRentPercentage,
          renewalRecurringConcessionMarketRentPercentage: budgetSettings.renewalRecurringConcessionMarketRentPercentage,
          otherConcessionTransactionCategories: budgetSettings.otherConcessionTransactionCategories,
          badDebtOption: budgetSettings.badDebtOption,
          badDebtGLPercentage: budgetSettings.badDebtGLPercentage,
          badDebtTransactionCategoryId: budgetSettings.badDebtTransactionCategoryId,
          approvalWorkflowId: budgetSettings.approvalWorkflowId,
          projectionLastUpdatedDate: budgetSettings.projectionLastUpdatedDate
        };

        this.$refs.propertySelector.selectItem(this.budgetSettings.property);
        this.$refs.templateSelector.selectItem(this.budgetSettings.template);

        setTimeout(() => {
          if (this.transactionCategories.length > 0) {
            let fullOtherConcessionTransactionCategories = [];
            this.transactionCategories.forEach((cat) => {
              if (cat.value == budgetSettings.badDebtTransactionCategoryId) {
                this.budgetSettings.badDebtTransactionCategoryId = cat;
                if (this.$refs.badDebtCombo) {
                  this.$refs.badDebtCombo.selectItem(cat);
                }
              }
              if (cat.value == budgetSettings.newRecurringConcessionTransactionCategoryId) {
                this.budgetSettings.newRecurringConcessionTransactionCategoryId = cat;
              }
              if (cat.value == budgetSettings.renewalRecurringConcessionTransactionCategoryId) {
                this.budgetSettings.renewalRecurringConcessionTransactionCategoryId = cat;
              }
              var index = budgetSettings.otherConcessionTransactionCategories.indexOf(cat.value);
              if (index !== -1) {
                fullOtherConcessionTransactionCategories.push(cat);
                budgetSettings.otherConcessionTransactionCategories.splice(index, 1)
              }
            })
            this.budgetSettings.otherConcessionTransactionCategories = fullOtherConcessionTransactionCategories;
          }
          if (this.glAccounts.length > 0) {
            this.glAccounts.forEach((gl) => {
              if (gl.value == budgetSettings.badDebtGLAccount) {
                this.budgetSettings.badDebtGLAccount = gl;
                if (this.$refs.glCombo) {
                  this.$refs.glCombo.selectItem(gl);
                }
              }
            });
          }

        }, 5000);
        this.lastModifiedTimestamp = this.budgetSettings.lastModifiedTimestamp = budgetSettings.lastModifiedTimestamp;
        await this.loadProjectedVacancies();
      },
      async create() {
        this.changeLoading(true);
        let newBudgetId = false;
        this.showMessageDialog = true;
        newBudgetId = await budgetService.createBudget(this.budgetSettings);
        this.showMessageDialog = false;
        this.$emit('save', newBudgetId);
        if (newBudgetId) {
          this.$router.push({ name: 'BaseRent', params: { budgetIterationId: newBudgetId } });
          setTimeout(() => {
            this.$eventHub.$emit('budgetSettingsUpdated', newBudgetId);
            this.changeLoading(false);
          }, 2000);
        }
      },
      async save() {
        this.changeLoading(true);
        let succeeded = false;

        succeeded = await budgetService.updateBudgetSettings(this.budgetIterationId, this.budgetSettings);

        this.$emit('save', succeeded);
        if (succeeded) {
          this.$eventHub.$emit('budgetSettingsUpdated', this.budgetIterationId);
        }
        this.changeLoading(false);
      },
      cancel() {
        this.$emit('cancel', true)
      },
      resetWRCopy() {
        this.copyWorkingRowsYear = null;
        this.copyableWorkingRowSets = [];
        this.budgetSettings.cloneWorkingRowsFromBudgetIterationId = null
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
      startMonthOptions() {
        return this.getMonthOptions(this.budgetSettings.year, true)
      },
      accountingBasiiOptions() {
        return [
          { text: 'Accrual', value: 1 },
          { text: 'Cash', value: 2 }
        ]
      },
      estimateFutureHistoricalsOptions() {
        var currentYear = this.budgetSettings.startMonth == 1 ? this.budgetSettings.year - 1 : this.budgetSettings.year - 1;
        return [
          { text: `Estimate Future Historicals by annualizing current year (${currentYear}) actuals`, value: 1 },
          { text: `Estimate Future Historicals by using prior year (${currentYear - 1}) actuals`, value: 2 },
          { text: `Estimate Future Historicals using current year (${currentYear}) budget`, value: 3 },
          { text: `Estimate Future Historicals by using current year (${currentYear}) reforecast`, value: 4 },
          { text: `Do not Estimate Future Historical months`, value: 5 }
        ]
      },
      estimateFutureHistoricalOptionMonthOptions() {
        var currentYear = this.budgetSettings.startMonth == 1 ? this.budgetSettings.year - 1 : this.budgetSettings.year - 1;
        var startMonth = this.budgetSettings.startMonth - 1 + 12;
        var options = []
        switch (this.budgetSettings.estimateFutureHistoricalsOption) {
          case 1:
            options = this.getMonthOptions(currentYear, true, startMonth);
            break;
          case 2:
            options = this.getMonthOptions(currentYear - 1, true, startMonth);
            break;
          case 3:
            options = this.getMonthOptions(currentYear, true, startMonth);
            break;
          case 4:
            options = this.getMonthOptions(currentYear, true, startMonth);
            break;
          case 5:
            options = this.getMonthOptions(currentYear, true, startMonth)
            break;
        } 
        return options;
      },   
      estimateFutureHistoricalsOccupancyWorkbooksOptions() {
        var currentYear = this.budgetSettings.startMonth == 1 ? this.budgetSettings.year - 1 : this.budgetSettings.year - 1;
        return [
          { text: `Estimate Future Historicals by annualizing current year (${currentYear}) actuals`, value: 1 },
          { text: `Estimate Future Historicals by using prior year (${currentYear - 1}) actuals`, value: 2 },
          { text: `Do not Estimate Future Historical Months`, value: 3 },
        ]
      },
      newLeaseCalculationOptions() {
        return [
          { text: 'New Leases will be given a percentage discount off of Market Rent (yes Gain/Loss to Lease)', value: 1 },
          { text: 'New Leases will be at Market Rent (no Gain/Loss to Lease)', value: 2 },
          { text: 'New Leases will be at Market Rent AND also offer a recurring concession (no Gain/Loss to Lease)', value: 3 }
        ]
      },
      renewalPricingCalculationOptions() {
        return [
          { text: 'Renewals will be given an increase over existing Rent', value: 1 },
          { text: 'Renewals will be at Market Rent', value: 2 },
          { text: 'Renewals will be at Market Rent AND also offer a recurring concession', value: 3 }
        ]
      },
      badDebtOptions() {
        return [
          { text: 'Bad Debt will be a percentage of the selected GL Account', value: 1 },
          { text: 'Bad Debt will be Average Market Rent multiplied by the number of skips/evictions', value: 2 },
          { text: 'Manual Entry', value: 3 }
        ]
      },
      projectedVacancyDate() {
        if (this.budgetSettings.startMonth > 0 && this.budgetSettings.year > 0) {
          let adjustedYear =  this.budgetSettings.startMonth>1?this.budgetSettings.year - 1:this.budgetSettings.year;
          return fiscalYearOperations.getEndOfPriorFiscalYear(this.budgetSettings.startMonth, adjustedYear);
        }
        return null;
      },
      denominationOptions() {
        return [
          { text: 'dollars ($)', value: 1 },
          { text: 'percent (%)', value: 2 }
        ];
      },
      canEdit() {
        return this.budgetSettings.status == 'Open' || !(this.budgetIterationId);
      }
    },
    mounted() {
      this.loadGlAccounts();
      this.loadBudgetSettings();
    },
    watch: {
      'budgetSettings.property.value': function (newVal) {
        if (newVal) {
          this.selectDefaultMonth(newVal);
          this.getConcessionTransactionCategories(newVal);
          this.loadUnitTypes()
          this.loadAvailableWorkflows();
        }
      },
      'estimateFutureHistoricalOptionMonthOptions': function (options) {
        var currentMonthOption = options.filter((m) => m.value == (new Date).getMonth() + 1)[0];
        this.budgetSettings.estimateFutureHistoricalOptionMonthOption = this.budgetSettings.estimateFutureHistoricalOptionMonthOption || (currentMonthOption && currentMonthOption.value);
      },
      'copyWorkingRowsYear': async function (newVal) {
        if (newVal) {
          this.changeLoading(true);
          var budgetList = await budgetService.getAll(this.copyWorkingRowsPropertyId.value, false, this.copyWorkingRowsYear, 0);
          this.copyableWorkingRowSets = (budgetList.data && budgetList.data.map((b) => { return { text: b.accountingBasis + ' | ' + b.version, value: b.budgetIterationId } })) || [];
          this.changeLoading(false);
        }
      },
      'copyWorkingRowsPropertyId': function () {
        this.resetWRCopy();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .v-stepper,
  .v-stepper__header,
  .v-card.v-sheet {
    box-shadow: none;
  }

  .inline {
    display: inline !important;
  }

  .step-title {
    text-align: center;
    font-size: 24px;
    padding-bottom: 0;
    font-weight: bold;
    display: block;
  }

  .banner {
    text-align: center;
    background-color: var(--v-resGrey-lighten1);
    display: block;
  }

  .step-down {
    position: relative;
    top: 18px;
  }

  .resGrey--border {
    border: 1px solid var(--v-resGrey-darken1) !important;
    padding: 8px;
  }

  .help-controls {
    float: right;
    border-radius: 5px;
    border: solid 1px var(--v-resGrey-lighten3);
    padding: 7px 6px 6px 6px;
    cursor: pointer;
  }
  .nudge-left {
      margin-left:-40px;
  }
</style>

<style>
  #new-edit-budget-dialog .v-stepper,
  #new-edit-budget-dialog .v-stepper__items,
  #new-edit-budget-dialog .v-stepper__wrapper {
    overflow: initial
  }
  div[role="combobox"] .v-text-field.v-text-field--solo .v-input__control {
    min-height: 20px;
  }

  div[role="combobox"] .v-input__append-inner {
    background-color: var(--v-resBlue-darken1);
    margin-top: 0 !important;
    margin-right: 0;
    position: absolute;
    right: -13px;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
  }

  div[role="combobox"] .v-input__append-inner {
    padding-bottom: 7px !important;
  }

  div[role="combobox"] .v-input__icon--append {
    margin-top: -3px;
  }

  div[role="combobox"] .v-input__append-inner .v-icon {
    color: white !important;
  }

  .v-input--is-readonly div[role="combobox"],
  .v-input--is-readonly input[readonly="readonly"],
  .v-input--is-readonly .v-select__slot {
    opacity: 0.65;
  }

  div[role="combobox"] .v-input__append-inner {
    height: 40px !important;
  }

  div[role="combobox"] .v-input__icon.v-input__icon--append {
    margin-top: 8px;
    margin-left: 3px;
    padding-right: 5px;
  }

  div#new-edit-budget-dialog .v-stepper__content {
      transform-origin:center !important;
      transform: none !important;
      transition:none !important;
  }

  .scrollable-card {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .short fieldset {
      height:37px;
  }
</style>
